/**
 * Which environment Sentry files an error under. Shared by the browser, server and edge configs.
 *
 * NODE_ENV is "production" on EVERY Vercel build, previews included, so previews used to report as
 * production. That matters because the ownly-jobs crash digest opens an auto-fix ticket for every new
 * production crash: a half-finished preview branch could start a real fix session against main.
 * VERCEL_ENV tells them apart. It is inlined at build time by next.config.ts as
 * NEXT_PUBLIC_SENTRY_ENVIRONMENT so the browser bundle gets the same answer as the server.
 *
 *   production  -> "production"  (the live site, the only one the digest reads)
 *   preview     -> "preview"
 *   local       -> "development"
 */
export const sentryEnvironment =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";
